/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { itemMoveItem } from '../fn/item/item-move-item';
import { ItemMoveItem$Params } from '../fn/item/item-move-item';
import { itemRemoveItem } from '../fn/item/item-remove-item';
import { ItemRemoveItem$Params } from '../fn/item/item-remove-item';
import { itemSetItem } from '../fn/item/item-set-item';
import { ItemSetItem$Params } from '../fn/item/item-set-item';
import { itemSetItems } from '../fn/item/item-set-items';
import { ItemSetItems$Params } from '../fn/item/item-set-items';
import { itemSetTranslation } from '../fn/item/item-set-translation';
import { ItemSetTranslation$Params } from '../fn/item/item-set-translation';
import { itemSetTranslations } from '../fn/item/item-set-translations';
import { ItemSetTranslations$Params } from '../fn/item/item-set-translations';

@Injectable({ providedIn: 'root' })
export class ItemService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemMoveItem()` */
  static readonly ItemMoveItemPath = '/api/Item/{itemId}/move/{sectionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemMoveItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemMoveItem$Response(params: ItemMoveItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemMoveItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemMoveItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemMoveItem(params: ItemMoveItem$Params, context?: HttpContext): Observable<void> {
    return this.itemMoveItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemSetItem()` */
  static readonly ItemSetItemPath = '/api/Item/set';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemSetItem()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetItem$Response(params?: ItemSetItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemSetItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemSetItem$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetItem(params?: ItemSetItem$Params, context?: HttpContext): Observable<void> {
    return this.itemSetItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemSetItems()` */
  static readonly ItemSetItemsPath = '/api/Item/set-many';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemSetItems()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetItems$Response(params?: ItemSetItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemSetItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemSetItems$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetItems(params?: ItemSetItems$Params, context?: HttpContext): Observable<void> {
    return this.itemSetItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemRemoveItem()` */
  static readonly ItemRemoveItemPath = '/api/Item/{itemId}/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemRemoveItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemRemoveItem$Response(params: ItemRemoveItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemRemoveItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemRemoveItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  itemRemoveItem(params: ItemRemoveItem$Params, context?: HttpContext): Observable<void> {
    return this.itemRemoveItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemSetTranslation()` */
  static readonly ItemSetTranslationPath = '/api/Item/{itemId}/translation/set';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemSetTranslation()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetTranslation$Response(params: ItemSetTranslation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemSetTranslation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemSetTranslation$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetTranslation(params: ItemSetTranslation$Params, context?: HttpContext): Observable<void> {
    return this.itemSetTranslation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `itemSetTranslations()` */
  static readonly ItemSetTranslationsPath = '/api/Item/{itemId}/translation/set-many';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `itemSetTranslations()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetTranslations$Response(params: ItemSetTranslations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return itemSetTranslations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `itemSetTranslations$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  itemSetTranslations(params: ItemSetTranslations$Params, context?: HttpContext): Observable<void> {
    return this.itemSetTranslations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
